import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { get } from "lodash";
import { uploadFile } from "../file/services";
import { FileTypeEnum } from "../../utils/enum";
import config from "../../constant";

function Tinymce(props: any) {
  const handleEditorChange = (e: any) => {
    props.onChangeHtml(e.target.getContent());
  };
  const handleChange = async ({
    file,
    callback,
  }: {
    file: File;
    callback: (link: string, { alt }: { alt: string }) => void;
  }) => {
    if (file) {
      const data = await uploadFile({
        file: get(file, "[0]"),
        name: get(file, "[0].name"),
        minType: get(file, "[0].type"),
        type: FileTypeEnum.POST,
      });
      const id = get(data, "data.id");
      if (id) {
        const link = `${process.env.REACT_APP_API_URL}file/detail/${id}?token=${config.STATIC_API_TOKEN}`;
        callback(link, { alt: get(file, "[0].name") || "" });
      }
    }
  };
  // Tên nút theo TinyMCE 6+ (bản cloud đang tải). Font do website quy định (Roboto / FS PF BeauSans Pro).
  const toolbar = `undo redo | blocks fontsize | bold italic underline forecolor backcolor |
  alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
  table | image link | removeformat code
  `;
  return (
    <div>
      <input
        id="my-file"
        type="file"
        name="my-file"
        style={{ display: "none" }}
        // onChange=""
      />
      <Editor
        apiKey="qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc"
        {...props}
        // initialValue="<p>This is the initial content of the editor</p>"
        plugins="advlist autolink lists link image charmap preview anchor
                          searchreplace visualblocks code fullscreen
                          insertdatetime media table help wordcount"
        init={{
          selector: "textarea",
          toolbar,
          font_size_formats: "12px 14px 15px 16px 18px 20px 24px 28px 32px",
          font_family_formats:
            "Roboto=Roboto,sans-serif; FS PF BeauSans Pro=FS PFBeauSansPro,sans-serif",
          // Bỏ font-family dán kèm từ Word/web khác để website hiển thị đồng nhất
          invalid_styles: { "*": "font-family" },
          content_style:
            "@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'); body { font-family: Roboto, sans-serif; font-size: 15px; line-height: 1.6; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #e5e7eb; padding: 8px 12px; }",
          table_default_styles: { width: "100%", "border-collapse": "collapse" },
          file_picker_types: "image",
          height: 500,
          init_instance_callback: function (editor) {
            var freeTiny: any = document.querySelector(".mce-notification");
            if(freeTiny) {
              freeTiny.style.display = "none";
            }
          },
          file_picker_callback: function (callback, value, meta) {
            // Provide image and alt text for the image dialog
            if (meta.filetype === "image") {
              var input = document.getElementById("my-file");
              if (input) {
                input.click();
                input.onchange = function () {
                  const file: any = get(input, "files");
                  handleChange({ file, callback });
                };
              }
              // UploadImgComponent
              // callback(
              //   "https://viettelhightech.com/storage/banner-trang-chu/artboard-4-2880x1380.png",
              //   { alt: "My alt text" }
              // );
            }

          },
        }}
        onChange={handleEditorChange}
      />
    </div>
  );
}

export default Tinymce;
